"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesFolderPropertiesOverlay = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var SubprojectActions = require("@caddigital/sok-reducers/lib/actions/subproject");
var FilesFolderPropertiesOverlay_1 = require("components/sidemenus/FilesFolderPropertiesOverlay");
var mapStateToProps = function (state) { return ({
    filesFolderProperties: state.files.filesFolderProperties,
    subproject: state.subproject.usergroups
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    closeOverlay: function () { return dispatch(FilesActions.PropertiesActions.closeOverlay()); },
    save: function (file, schema, values, mode) {
        return dispatch(FilesActions.PropertiesActions.savePropertiesRequest(file, schema, values, mode));
    },
    fetchSubprojectGroups: function (folder) {
        return dispatch(SubprojectActions.usergroupList.fetchRequest('SUBPROJECT', folder.id));
    },
    clearSubproject: function () { return dispatch(SubprojectActions.usergroupList.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var FilesFolderPropertiesOverlayComponent = function (props) {
    return React.createElement(FilesFolderPropertiesOverlay_1.FilesFolderProperties, props);
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.filesFolderProperties.mode === 'EDIT_SUBPROJECT' &&
            prevProps.filesFolderProperties.mode !==
                this.props.filesFolderProperties.mode) {
            var folder = this.props.filesFolderProperties.file;
            if (folder.type === 'FOLDER') {
                this.props.fetchSubprojectGroups(folder);
            }
        }
        else if (prevProps.filesFolderProperties.mode === 'EDIT_SUBPROJECT' &&
            prevProps.filesFolderProperties.mode !==
                this.props.filesFolderProperties.mode) {
            this.props.clearSubproject();
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if ((this.props.filesFolderProperties.mode.includes('EDIT') &&
            !nextProps.filesFolderProperties.mode.includes('EDIT')) ||
            (!this.props.filesFolderProperties.mode.includes('EDIT') &&
                nextProps.filesFolderProperties.mode.includes('EDIT')) ||
            (this.props.filesFolderProperties.mode.includes('EDIT') &&
                nextProps.filesFolderProperties.mode.includes('EDIT'))) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.FilesFolderPropertiesOverlay = enhance(FilesFolderPropertiesOverlayComponent);
